import { render, staticRenderFns } from "./gjgxjy.vue?vue&type=template&id=5c406f0b&scoped=true&"
import script from "./gjgxjy.vue?vue&type=script&lang=js&"
export * from "./gjgxjy.vue?vue&type=script&lang=js&"
import style0 from "./gjgxjy.vue?vue&type=style&index=0&id=5c406f0b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c406f0b",
  null
  
)

export default component.exports